import { render, staticRenderFns } from "./ModalIncompatibleItem.vue?vue&type=template&id=6e8a3340&scoped=true"
import script from "./ModalIncompatibleItem.vue?vue&type=script&lang=js"
export * from "./ModalIncompatibleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a3340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8a3340')) {
      api.createRecord('6e8a3340', component.options)
    } else {
      api.reload('6e8a3340', component.options)
    }
    module.hot.accept("./ModalIncompatibleItem.vue?vue&type=template&id=6e8a3340&scoped=true", function () {
      api.rerender('6e8a3340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalIncompatibleItem.vue"
export default component.exports